package kz.dentalcrm.app.screens.positions.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddPositionViewEvent : ViewEvent {
    data class AddPosition(val name: String, val description: String) : AddPositionViewEvent
    data object Reset : AddPositionViewEvent
}
